import { useCookieConsentStore } from "~/layers/base/stores/cookieConsentStore";

export default defineNuxtPlugin((nuxtApp) => {
	// Hydrate AFTER the app has mounted: the server can't read the decision
	// (SSR HTML is cached, so it must not depend on the consent cookie) and
	// always renders the banner. Reading the cookie before hydration made the
	// client vdom diverge from that HTML (banner hidden vs rendered) — a
	// structural hydration mismatch that, on slow connections, shifted the
	// pending page fragment's anchors and inserted page content after the
	// footer.
	nuxtApp.hook("app:mounted", () => {
		const store = useCookieConsentStore();
		store.hydrateFromCookie();

		if (store.hasDecided) {
			const w = window as unknown as { dataLayer?: unknown[] };
			w.dataLayer = w.dataLayer || [];
			w.dataLayer.push(["consent", "update", store.googleConsentPayload]);
		}
	});
});
